/**
 * Installation vs removal labels and field accessors for invoice UI.
 */

import type { InvoiceType } from "./invoiceDocumentTypes";

export function normalizeInvoiceTypeFromOrder(order: any): InvoiceType | null {
  const raw = String(order?.order_type ?? order?.type ?? "").trim().toLowerCase();
  if (raw === "installation" || raw === "removal" || raw === "sales") return raw;
  return null;
}

export function deliveryAddressLabel(isSales: boolean, isInstall: boolean): string {
  if (isSales) return "Shipping Address";
  if (isInstall) return "Installation Address";
  return "Removal Address";
}

export function deliveryAddressLabelForOrder(effType: InvoiceType, order: any): string {
  const kind = normalizeInvoiceTypeFromOrder(order) ?? effType;
  return deliveryAddressLabel(kind === "sales", kind === "installation");
}

export function jobDetailsSectionTitle(isInstall: boolean): string {
  return isInstall ? "Installation Details" : "Removal Details";
}

export function serviceCostLineLabel(isInstall: boolean): string {
  return isInstall ? "Installation Cost" : "Removal Cost";
}

export function getInstallerNameForJobInvoice(isInstall: boolean, effOrder: any): any {
  return isInstall
    ? effOrder?.installation_details?.installer_name
    : effOrder?.removal_details?.installer_name;
}

export function getGateAccessCodeForJobInvoice(isInstall: boolean, effOrder: any): any {
  return isInstall
    ? effOrder?.gate_access_code ?? effOrder?.installation_details?.gate_access_code
    : effOrder?.gate_access_code ?? effOrder?.removal_details?.gate_access_code;
}
